module.exports = __webpack_public_path__ + "assets/img/list-2.0ad1268d.png";